// extracted by mini-css-extract-plugin
module.exports = {"tabBar":"tabBar_tabBar__7c_Jy","tab":"tabBar_tab__C_olA","tab__active":"tabBar_tab__active__Eew3T","tab__disabled":"tabBar_tab__disabled__zq92R"};